import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Signaalkaart} from '../signaalkaart';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SignaalkaartAntwoord, VraagAntwoord} from '../signaalkaart-antwoord';
import {Vraag} from '../vraag';

@Component({
    selector: 'zah-signaalkaart',
    templateUrl: './signaalkaart.component.html',
    styleUrls: ['./signaalkaart.component.scss'],
    standalone: false
})
export class SignaalkaartComponent implements OnInit {

  @Input()
  signaalkaart: Signaalkaart;
  @Input()
  signaalkaartAntwoord: SignaalkaartAntwoord;
  @Output()
  cancelClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  okClicked: EventEmitter<[string, number, Array<VraagAntwoord>]> = new EventEmitter<[string, number, Array<VraagAntwoord>]>();

  signaalkaartForm: FormGroup;

  ngOnInit(): void {
    const controls = this.signaalkaart.getVragen()
      .map(vraag => ({
        [vraag.getId()]: new FormControl(
          {
            value: this.signaalkaartAntwoord ? this.getSignaalkaartAntwoord(vraag) : undefined,
            disabled: !!this.signaalkaartAntwoord
          },
          vraag.isRequired() ? [Validators.required] : [],
        )
      }))
      .reduce(((previous, current) => ({...previous, ...current})), {});
    this.signaalkaartForm = new FormGroup(controls);
  }

  private getSignaalkaartAntwoord(vraag: Vraag): string {
    return this.signaalkaartAntwoord?.getAntwoord(vraag.getId())?.getAntwoordenAsString() || ' ';
  }

  onCancelClicked(): void {
    this.cancelClicked.emit();
  }

  onOkClicked(): void {
    const antwoorden = this.signaalkaart.getVragen()
      .map(vraag => VraagAntwoord.newVraagAntwoord(vraag.getId(), this.getControl(vraag.getId()).value));
    this.okClicked.emit([this.signaalkaart.getId(), this.signaalkaart.getVersie(), antwoorden]);
  }

  getControl(name: string): FormControl {
    return this.signaalkaartForm.controls[name] as FormControl;
  }
}
